import React from 'react';

// This adds a spinner container that has the style for the css animated spinner. It will stretch to fit whatever container it is in so that

function LoadingSpinner() {
  return (
    <div className="loading-spinner__container">
      <div className="loading-spinner__spinner" />
    </div>
  );
}

export default LoadingSpinner;
